var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserInviteIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.177,
    height: 18.197,
    viewBox: "0 0 28.177 18.197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-221.409 -78.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.412 81.027)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.745)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.122,
    cy: 4.122,
    r: 4.122,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.122,
    cy: 4.122,
    r: 3.122,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.745)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.122,
    cy: 4.122,
    r: 4.122,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.122,
    cy: 4.122,
    r: 3.122,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.521 15.664) rotate(180)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.524,0A7.262,7.262,0,0,1,7.262,7.262,7.262,7.262,0,0,1,0,0C-.024.014,14.481.074,14.524,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.401861190795898 2.016850471496582 C 3.194655418395996 3.920413970947266 5.074467658996582 5.261800765991211 7.261828422546387 5.261800765991211 C 9.44263744354248 5.261800765991211 11.31790828704834 3.928027391433716 12.11481475830078 2.033529281616211 C 11.53987884521484 2.03526496887207 10.867431640625 2.036140918731689 10.10309886932373 2.036140918731689 C 8.232028961181641 2.036140918731689 5.806578636169434 2.03075122833252 3.448668479919434 2.021341323852539 C 3.079521179199219 2.019871234893799 2.728658676147461 2.018362045288086 2.401861190795898 2.016850471496582 M 2.86102294921875e-05 9.5367431640625e-07 C -6.67572021484375e-06 4.529953002929688e-05 -8.58306884765625e-06 2.288818359375e-05 2.86102294921875e-05 9.5367431640625e-07 Z M 14.52362823486328 9.5367431640625e-07 C 14.52362823486328 4.010581016540527 11.2724084854126 7.261801242828369 7.261828422546387 7.261801242828369 C 3.251248359680176 7.261801242828369 2.86102294921875e-05 4.010581016540527 2.86102294921875e-05 9.5367431640625e-07 C 0.01427459716796875 0.008766651153564453 5.835726737976074 0.03613662719726563 10.10310173034668 0.03613662719726563 C 12.56398963928223 0.03613662719726563 14.50802135467529 0.02703475952148438 14.52362823486328 9.5367431640625e-07 Z",
    stroke: "none",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(231.967 80.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.654,0S1.377-.007,0,0C0,2.841,2.649,5.145,5.917,5.145H7.752",
    transform: "translate(12.521 15.444) rotate(180)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    y2: 4.086,
    transform: "translate(246.543 79.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.086,
    transform: "translate(244.5 81.543)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInviteIconWhite);
export default __webpack_public_path__ + "static/media/userInviteIconWhite.e1cd12e8689665062a629b90dcaf8f8e.svg";
export { ForwardRef as ReactComponent };